var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#158AFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-69-Copy",
    fill: "#FDD216",
    mask: "url(#mask-2)",
    transform: "translate(13.317049, 10.417673) rotate(153.000000) translate(-13.317049, -10.417673) ",
    points: "-6.01628388 6.41767333 32.6503828 6.41767333 32.6503828 14.4176733 -6.01628388 14.4176733"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-69",
    fill: "#CE1120",
    mask: "url(#mask-2)",
    transform: "translate(13.684917, 10.174930) rotate(153.000000) translate(-13.684917, -10.174930) ",
    points: "-5.64841655 7.50826297 33.0182501 7.50826297 33.0182501 12.8415963 -5.64841655 12.8415963"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "#FDD216",
    mask: "url(#mask-2)",
    points: "4.66666667 5.96666672 2.70738249 7.36338998 3.43029315 5.06838878 1.49647828 3.63661002 3.90254581 3.61494453 4.66666667 1.33333333 5.43078753 3.61494453 7.83685505 3.63661002 5.90304019 5.06838878 6.62595084 7.36338998"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/CD.6da2af09deccc5051560d555917fdb84.svg";
export { ForwardRef as ReactComponent };